const s = {
  name: "Users5",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,0C6.8,0,5,1.8,5,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C13,1.8,11.2,0,9,0z M7,4c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C7.9,6,7,5.1,7,4z"/>
		<path class="st0" d="M20,10c-2.2,0-4,1.8-4,4s1.8,4,4,4c2.2,0,4-1.8,4-4S22.2,10,20,10z M18,14c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2
			s-0.9,2-2,2C18.9,16,18,15.1,18,14z"/>
		<path class="st0" d="M0,15c0-2.8,2.2-5,5-5h8v2H5c-1.7,0-3,1.3-3,3v5H0V15z"/>
		<path class="st0" d="M31,0c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4C35,1.8,33.2,0,31,0z M29,4c0-1.1,0.9-2,2-2
			c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2C29.9,6,29,5.1,29,4z"/>
		<path class="st0" d="M35,10c2.8,0,5,2.2,5,5v5h-2v-5c0-1.7-1.3-3-3-3h-8v-2H35z"/>
		<path class="st0" d="M9,20c-2.2,0-4,1.8-4,4s1.8,4,4,4c2.2,0,4-1.8,4-4S11.2,20,9,20z M7,24c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2
			c0,1.1-0.9,2-2,2C7.9,26,7,25.1,7,24z"/>
		<path class="st0" d="M0,35c0-2.8,2.2-5,5-5h8c2.8,0,5,2.2,5,5v5h-2v-5c0-1.7-1.3-3-3-3H5c-1.7,0-3,1.3-3,3v5H0V35z"/>
		<path class="st0" d="M31,20c-2.2,0-4,1.8-4,4s1.8,4,4,4c2.2,0,4-1.8,4-4S33.2,20,31,20z M29,24c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2
			c0,1.1-0.9,2-2,2C29.9,26,29,25.1,29,24z"/>
		<path class="st0" d="M22,35c0-2.8,2.2-5,5-5h8c2.8,0,5,2.2,5,5v5h-2v-5c0-1.7-1.3-3-3-3h-8c-1.7,0-3,1.3-3,3v5h-2V35z"/>
		<path class="st0" d="M16,20v2h8v-2H16z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Users5
};
